module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0003.c00c3829.jpg";